export const types = {
    SET_GET_POSTBACK_LOGS: '[POSTBACK] SET GET POSTBACK LOGS'
}